export default "__VITE_ASSET__BjhDgTeT__"